export default {
  notifyUsers: 'Notify users about added lunch.',
  date: 'Date',
  providers: 'Providers',
  touchDeviceTooltip: 'Long Press a Provider for context menu.',
  desktopTooltip: 'Right click a Provider for context menu.',
  ordersCount: '{count} Order(s)',
  notApproved: 'Not approved',
  approve: 'Approve',
  noProviders: 'No Providers.',
  startBy: 'Start by ',
  cannotAddAnyMore: 'Cannot add providers to the past.',
  addingOne: 'adding one.',
  settings: 'Settings',
  freeOfCharge: 'Free Of Charge',
  comment: 'Comment',
  copyModalTitle: 'Select a day and a provider to copy.',
  copyModalSubtitle: 'You will be taken to provider edit modal.',
  noProvidersFound: 'No Providers found.',
  dishes: '{count} dishes',
  addProvider: 'Add a new Provider.',
  getLink: 'Get link for adding a provider.',
  copyProvider: 'Copy provider from other day.',
  providerSettings: 'Provider Settings',
  categories: 'Categories',
  providerName: 'Provider Name',
  color: 'Color',
  providerColor: 'Provider Color',
  categoryName: 'Category Name',
  translation: 'Translation',
  soups: 'Soups',
  mains: 'Main Dishes',
  dish: 'Dish',
  multiple: '(Multiple)',
  selectionName: 'Selection Name',
  orderUntilDay: 'Order Until (Day)',
  orderUntilHour: 'Order Until (Hour)',
  category: '{category} category',
  createLink: 'Create Link for Adding a Provider',
  selectedWeek: 'Selected Week',
  link: 'Link',
  generateLink: 'Generate Link',
  succesfullySaved: 'Provider Succesfully saved.',
  promptDishRatings: 'Remind Users to Rate Lunch',
  unableToEdit: 'Unable to edit days from last week.',
  unableToDeleteProvider: 'Unable to delete provider, because it already has orders or is in the previous week.',
  unableToDeleteDish: 'Not allowed to delete dish, that was already ordered ({count} orders)',
  invalidFields: 'Form contains incorrect field(s): {fields}',
  emptyCategories: 'Form contains empty categories, add dishes or remove these categories: {categories}, ',
  manageProviders: 'Manage providers',
};
